import { ERROR_CODE
       , TEXT
       , tr }                     from '../00_assets' ;

export enum API_METHOD
{ LIST = 1
, ADD
, UPDATE
, DEL
, FETCH
, POST
} ;

export const API_GENERAL_ERROR = ( ) =>
({ data: null
 , error:
   { code: ERROR_CODE.SOMETHING_WAS_WRONG
   , msg: tr( TEXT.ERROR_UNKNOWN ) 
   }
}) ;

export enum ROLE
{ USER    = 'USER'
, MANAGER = 'MANAGER'
, ADMIN   = 'ADMIN'
} ;


export const ROLE_AUTH =
{ [ ROLE.USER    ]: 0
, [ ROLE.MANAGER ]: 1
, [ ROLE.ADMIN   ]: 2
} ;


export enum LICENSE
{ LITE = 'LITE'
} ;

export enum JOB_STATUS
{ PENDING    = 'PENDING'
, COMPLETE   = 'COMPLETE'
, CANCELLED  = 'CANCELLED'
, PROCESSING = 'PROCESSING'
, UNDEFINED  = '---'
} ;


export interface kde_api_error_response_t
{
  timestamp: string // ISO format
  status: ERROR_CODE
  error: string
  message: string
  path: string
}


export declare type kde_api_response_t =
    kde_api_error_response_t 
  | kde_api_login_response_t
  | kde_api_workgroup_t[] ;


export type connect_t = kde_api_response_t ;


export interface api_error_t
{
  code: number
}


export interface api_response_t
{
  data: kde_api_response_t | null
  error: api_error_t
}



export interface kde_api_enum_t
{
  id: number
  name: string
}


export interface kde_api_data_sheet_t
{
  id: string
}

///////////
// LOGIN //
///////////

export interface kde_api_login_response_t
{
  user: kde_api_logged_user_t
  token: string
}

export interface kde_api_user_t
{
  id: number
  username: string
  email: string
  role: kde_api_role_t
  workgroup?: kde_api_workgroup_t
}


export interface kde_api_role_t
{ 
  id: number
  name: ROLE
}


export interface kde_api_logged_user_t extends kde_api_user_t
{
  workgroup: kde_api_workgroup_t
}

export interface kde_api_workgroup_t
{
  id: number
  name: string
  cloud: kde_api_cloud_t
  address: kde_api_client_address_t | null
  contact: kde_api_client_contact_t | null
  users?: kde_api_user_t[]
  machines?: kde_api_machine_t[]
}


interface kde_api_cloud_t
{
  id: number
  name: string
  description: string
  license: kde_api_license_t
}

interface kde_api_license_t
{ 
  id: number
  type: LICENSE
  workgroup_limit: number
  user_limit: number
}


export interface kde_api_machine_t
{
  id: number
  serialNo: string
  type: kde_api_enum_t
  name: string
  jobs?: kde_api_job_t[]
  workgroup: kde_api_workgroup_t
}


export interface kde_api_job_t
{
  id: number
  client: kde_api_client_t
  jobStatus: kde_api_job_status_t
  key: kde_api_key_t
  quantity: number
  creationDate: string
  machine?: kde_api_machine_t
}


export interface kde_api_job_status_t
{
  id: number
  name: string
}

export interface kde_api_client_t
{
  id: number
  name: string
  surnames: string
  notes: string | null
  birthday: string | null
  address: kde_api_client_address_t | null
  contact: kde_api_client_contact_t | null
  creationDate: string
}

export interface kde_api_client_contact_t
{
  email?: string
  phone?: string
  fax?: string  
}

export type kde_api_client_contact_fields_t = keyof kde_api_client_contact_t ;

export interface kde_api_client_address_t
{
  street1?: string
  street2?: string
  city?: string
  province?: string
  zipCode?: string
  country?: string
}

export type kde_api_client_address_fields_t = keyof kde_api_client_address_t ;


export interface kde_api_datasheet_t
{
  id: number
}


export interface kde_api_key_t
{
 id: number
 model: string
 series: string
 code: string
 datasheet: kde_api_datasheet_t
 biting: string
 application: kde_api_key_app_t
}

interface kde_api_key_app_t
{
  id: number
  name: string
}


export interface kde_api_pseudo_job_t
{
  id: number
  key: 
    { id: number
      model: string
      series: string
      code: string
      datasheet: kde_api_datasheet_t
      biting: string
      application: {id: number,name: string }
    }
  quantity: number
}

export interface kde_api_mastering_t
{
  id: number
  type: { id: number, name: string }
  mksJobs: kde_api_pseudo_job_t[]
  name: string
  client: kde_api_client_t
  workgroup: kde_api_workgroup_t
  creationDate: string
}
